import { useState } from 'react';
import { Card, Form, Spinner } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';

import { Chart } from '../components/vendor/Chart';
import { currencyFormatter } from '../helpers/currencyFormatter';
import { formatDateLabel } from '../helpers/dateRange';
import { DailyFinancialsResponse } from '../types/dashboard';

const CHART_BODY_MIN_HEIGHT = 300;

interface AnalyticsConversionsProps {
  data?: DailyFinancialsResponse;
  isLoading?: boolean;
}

export default function AnalyticsConversions({ data, isLoading, ...props }: AnalyticsConversionsProps) {
  const [showPrevious, setShowPrevious] = useState(false);

  const currentData = data?.current ?? [];
  const previousData = data?.previous ?? [];
  const hasData = !isLoading && currentData.length > 0;

  const labels = currentData.map(point => formatDateLabel(point.date));

  const datasets: any[] = [
    {
      label: 'Revenue',
      data: currentData.map(point => point.revenue)
    },
    ...(showPrevious && previousData.length > 0
      ? [
          {
            label: 'Previous Period',
            data: previousData.map(point => point.revenue),
            backgroundColor: '#d2ddec'
          }
        ]
      : [])
  ];

  const options = {
    scales: {
      y: {
        ticks: {
          callback: function (val: any) {
            return currencyFormatter(val);
          }
        }
      }
    }
  };

  return (
    <Card {...props}>
      <Card.Header>
        <h4 className="card-header-title">Revenue vs Expenses</h4>
        <span className="text-muted me-3">Last year comparison:</span>
        <Form.Check type="switch" id="cardToggle" onChange={e => setShowPrevious(e.target.checked)} />
      </Card.Header>
      <Card.Body
        style={{ minHeight: CHART_BODY_MIN_HEIGHT }}
        className="d-flex align-items-center justify-content-center"
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : hasData ? (
          <div className="w-100">
            <Chart>
              <Bar data={{ labels, datasets }} options={options} />
            </Chart>
          </div>
        ) : (
          <p className="text-muted text-center mb-0">No data available</p>
        )}
      </Card.Body>
    </Card>
  );
}
